import { FleetSignalsScreen } from "@src/features/patriot-tools";

export default FleetSignalsScreen;
